import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Grid from '@material-ui/core/Grid';
import BasicInput from '../common/BasicInput';
import {bindEmail, authCode, validEmail} from 'Actions/bind';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import {T} from 'Actions/translate';

class BindEmail extends Component {
    state = {
        email: '',
        code: '',
        isEmail: true,
        isBind: false,
        isBindEmail: true,
        isCodeButton: true,
        codeButton: T('getCode'),
    };

    componentDidMount() {}

    handleChange = (name, value) => {
        if (name === 'email') {
            const re =
                /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
            const isEmail = re.test(value);

            if (value !== '') {
                this.setState({isEmail: isEmail});
            } else {
                this.setState({isEmail: true});
            }
        }

        this.setState({[name]: value});
    };

    /**
     *  Send To Backend Request Validate Code
     *
     */
    getValidateCode = () => {
        if (this.state.email) {
            this.setTime(60);
            this.props.authCode(this.state.email, this.codeNotification);
        }
    };

    codeNotification = (res) => {
        const status = res.status;
        if (status === 'success') {
            this.props.openNotification(T('sendSuccess'), 'success');
        } else {
            this.props.openNotification(T('sendFailure'), 'danger');
        }
    };

    setTime = (countdown) => {
        if (countdown === 0) {
            this.setState({
                codeButton: T('getCode'),
                isCodeButton: true,
            });

            countdown = 60;
        } else {
            this.setState({
                codeButton: countdown + 's',
                isCodeButton: false,
            });

            countdown--;

            setTimeout(() => {
                this.setTime(countdown);
            }, 1000);
        }
    };

    /**
     *  Send To Backend Request Bind Email
     */
    bindEmail = () => {
        const data = {
            email: this.state.email,
            code: this.state.code,
        };

        this.props.bindEmail(data, this.bindNotification);
    };

    goToOrderPage = () => {
        this.props.history.push('/productList');
    };

    bindNotification = (res) => {
        const status = res.status;

        switch (status) {
            case 'success':
                this.props.openNotification(T('loginSuccess'), 'success');
                this.goToOrderPage();
                break;
            case 'repeat_binding':
                this.props.openNotification(T('isBindingEmail'), 'danger');
                break;
            case 'invalid_email':
                this.props.openNotification(T('unusedEmail'), 'danger');
                break;
            case 'invalid_code':
                this.props.openNotification(T('invalidCode'), 'danger');
                break;
            case 'code_overdue':
                this.props.openNotification(T('codeOverdue'), 'danger');
                break;
            default:
                this.props.openNotification(T('loginFailure'), 'danger');
                break;
        }
    };

    validEmail = () => {
        if (this.state.email) {
            this.props.validEmail(this.state.email, this.bindValidEmail);
        }
    };

    bindValidEmail = (res) => {
        switch (res.status) {
            case 'invalid_email':
                this.setState({
                    isBind: false,
                    isBindEmail: true,
                });
                break;
            case 'success':
                this.setState({
                    isBind: true,
                    isBindEmail: false,
                });

                if (this.state.isCodeButton) {
                    this.getValidateCode();
                }
                break;
            default:
                break;
        }
    };

    resetBindEmail = () => {
        this.setState({
            isBind: false,
            isBindEmail: false,
        });
    };

    render() {
        const {emailValid} = this.props;
        const {email, code, codeButton, isEmail, isBindEmail} = this.state;
        const loginBtnDisabled = !(isEmail && email !== '' && code !== '');

        return (
            <div className="bind-email">
                <Grid className="content-grid" container spacing={0}>
                    <Grid
                        className={
                            isEmail &&
                            isBindEmail &&
                            emailValid.status === 'invalid_email'
                                ? 'email-grid email-valid'
                                : 'email-grid'
                        }
                        item
                        xs={12}>
                        <BasicInput
                            title={'email'}
                            placeholder="enterEmail"
                            inputValid={this.handleChange}
                            blurFoucus={this.resetBindEmail}
                            type="email"
                            required
                        />
                    </Grid>
                    {!isEmail ? (
                        <Grid item xs={12}>
                            <span className="error-msg">{T('errorEmail')}</span>
                        </Grid>
                    ) : null}
                    {isEmail &&
                    isBindEmail &&
                    emailValid.status === 'invalid_email' ? (
                        <Grid item xs={12}>
                            <span className="error-msg">
                                {T('unusedEmail')}
                            </span>
                        </Grid>
                    ) : null}
                </Grid>

                <Grid className="content-grid" container spacing={0}>
                    <Grid className="content-border" container spacing={0}>
                        <Grid className="code-grid" item xs={7}>
                            <BasicInput
                                title={'code'}
                                placeholder=""
                                inputValid={this.handleChange}
                                required
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <BasicButton
                                type="info"
                                className="code-button"
                                onClickOfSingleTap={this.validEmail}>
                                {codeButton}
                            </BasicButton>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <div className="content-text">{T('noticeFour')}</div>
                    </Grid>
                </Grid>

                <Grid container spacing={0}>
                    <Grid className="content-grid" item xs={12}>
                        <BasicButton
                            type="primary"
                            className="bind-button"
                            disabled={loginBtnDisabled}
                            onClickOfSingleTap={this.bindEmail}>
                            {T('login')}
                        </BasicButton>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {bind} = state;

    return {
        customerUser: bind.customerUser,
        emailValid: bind.emailValid,
        authCode: bind.authCode,
    };
};

const mapDispatchToProps = {
    bindEmail,
    validEmail,
    openNotification,
    authCode,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(BindEmail);
